import dynamic from 'next/dynamic';
import Head from 'next/head';

import Layout from '#layout/index';

const Information = dynamic(import('#app/pages/contactanos-old/information'));
const WhyLearn = dynamic(import('#app/pages/home/why-learn'));
const ImageText = dynamic(import('#app/templates/new-image-text'));
const Typography = dynamic(import('#app/UI/atoms/new-typography'));
const Form = dynamic(import('#app/pages/contactanos-old/form'));

const ContactUsPage = () => {
  return (
    <>
      <Head>
        <title>Contáctanos | Crack The Code</title>
        <meta
          name="description"
          content="Somos una academia online que empodera a niños y jóvenes a través del código y la tecnología ¡Contáctanos para saber más!"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Layout mainType="full_variant">
        <ImageText
          first="text"
          image={{
            image: ['./contactanos/desktop.webp', './contactanos/desktop.webp'],
            width: [520, '100%'],
            height: [502, 343]
          }}
          className="pt-40 sm_pt-0 sm_px-20 gap-x-120 gap-y-40 sm_gap-y-20"
          maxWidth="1276px"
        >
          <Typography
            className="typo-56 font-bold mb-24"
            tag="h2"
            style={{ color: '#583AF0' }}
          >
            Contáctanos
          </Typography>

          <Form />
        </ImageText>

        <Information />

        <WhyLearn />
      </Layout>
    </>
  );
};

export default ContactUsPage;
